export const INIT_FLIGHTS = "INIT_FLIGHTS";
export const POLLING_FLIGHTS_REQUEST = "POLLING_FLIGHTS_REQUEST";
export const POLLING_FLIGHTS_FAILURE = "POLLING_FLIGHTS_FAILURE";
export const POLLING_FLIGHTS_SUCCESS = "POLLING_FLIGHTS_SUCCESS";
export const SET_DISPLAY_FLIGHT_SEARCH_FORM = "SET_DISPLAY_FLIGHT_SEARCH_FORM";
export const FETCHING_FLIGHT_INFO_REQUEST = "FETCHING_FLIGHT_INFO_REQUEST";
export const FETCHING_FLIGHT_INFO_FAILURE = "FETCHING_FLIGHT_INFO_FAILURE";
export const FETCHING_FLIGHT_INFO_SUCCESS = "FETCHING_FLIGHT_INFO_SUCCESS";
